import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'

import { mapRefundSubmission } from 'features/AdsManagement/helpers/mapRefundSubmission'
import { normalizeApprovalListPaginationCursors } from 'features/AdsManagement/helpers/normalizeApprovalListCursor'
import {
  postApproveSubmissionsAPI,
  postRejectSubmissionsAPI,
} from 'features/AdsManagement/services/principalList'
import {
  exportRefundSubmissions as exportRefundSubmissionsApi,
  getRefundSubmissions,
  type RefundListParamsType,
} from 'features/AdsManagement/services/refund'
import { toastSuccess } from 'utils/toast'

import {
  setIsExporting,
  setIsLoading,
  setIsSubmitting,
  setListFetchStatus,
  setPagination,
  setSubmissions,
  SLICE_NAME,
} from './slice'

export const fetchRefundSubmissions = createAsyncThunk(
  `${SLICE_NAME}/fetchRefundSubmissions`,
  async ({ params }: { params: RefundListParamsType }, { rejectWithValue, dispatch }) => {
    dispatch(setIsLoading(true))
    dispatch(setListFetchStatus('loading'))
    try {
      const response = await getRefundSubmissions(params)
      const items = response.data.data.refund_submissions.map(mapRefundSubmission)

      dispatch(setSubmissions(items))
      dispatch(setPagination(normalizeApprovalListPaginationCursors(response.data.pagination)))
      dispatch(setIsLoading(false))
      dispatch(setListFetchStatus('success'))
      return true
    } catch (error) {
      dispatch(setIsLoading(false))
      dispatch(setListFetchStatus('error'))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const approveRefundRequest = createAsyncThunk(
  `${SLICE_NAME}/approveRefundRequest`,
  async (
    { approvalSubmissionId }: { approvalSubmissionId: string },
    { rejectWithValue, dispatch },
  ) => {
    dispatch(setIsSubmitting(true))
    try {
      await postApproveSubmissionsAPI(approvalSubmissionId)
      dispatch(setIsSubmitting(false))
      toastSuccess('Pengajuan Refund berhasil disetujui!')
      return true
    } catch (error) {
      dispatch(setIsSubmitting(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const rejectRefundRequest = createAsyncThunk(
  `${SLICE_NAME}/rejectRefundRequest`,
  async (
    {
      approvalSubmissionId,
      rejectionNote,
    }: { approvalSubmissionId: string; rejectionNote: string },
    { rejectWithValue, dispatch },
  ) => {
    dispatch(setIsSubmitting(true))
    try {
      await postRejectSubmissionsAPI(approvalSubmissionId, rejectionNote)
      dispatch(setIsSubmitting(false))
      toastSuccess('Pengajuan Refund berhasil ditolak!')
      return true
    } catch (error) {
      dispatch(setIsSubmitting(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const exportRefundSubmissions = createAsyncThunk(
  `${SLICE_NAME}/exportRefundSubmissions`,
  async (
    { params }: { params: Omit<RefundListParamsType, 'page_cursor' | 'page_size'> },
    { rejectWithValue, dispatch },
  ) => {
    dispatch(setIsExporting(true))
    try {
      const response = await exportRefundSubmissionsApi(params)
      dispatch(setIsExporting(false))
      return response.data.file_url
    } catch (error) {
      dispatch(setIsExporting(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
